export default "__VITE_ASSET__CfKjEzKk__"